import * as ICS from 'ics-js';
import { saveAs } from 'file-saver';
import * as moment from "moment"
const ics= new ICS.VCALENDAR();

export interface IcsEvent {
  start: number[];//[YYYY,MM,GG,HH,mm]
  end?:number[];//[YYYY,MM,GG,HH,mm]  Va settata la fine o la durata
  duration?: Object;//{hours:number,minutes:number}
  title:string;
  description?: string;
  location?:string;
  url?:string;
  geo?:Object;//{lat:number,lon:number}
  categories?:string[],
  status:string;//https://www.kanzaki.com/docs/ical/status.html RFC
  organizer?:{name:string,email:string};
  attendees?:Object[]; //https://www.kanzaki.com/docs/ical/role.html RFC,
  productId?:string;
}

export interface InitIcsExporter {
  events?: any[];
  map?: { map: any; context?: any };
}

export class IcsExporter {

  private map: any;
  private mapContext: any;

  private rawEvents: any[] = [];
  private events: IcsEvent[] = [];

  private fileName: string = 'export';
  private exportType: 'xls' | 'xlsx' | 'csv' | 'txt' | 'ics' = 'ics';

  parse() {
    let e:any[] =[];
    let r=this.rawEvents;
    if (this.map) {
      r = this.rawEvents.map(this.map, this.mapContext);
    }
    for(let event of r){
      /*let obj:IcsEvent={
      start : moment(event.startDate).format('YYYY_MM_DD').split('_').map(el=>+el),
      duration : {hours:24},
      title : event.title,
      description : event.description? event.description:null,
      url : event.url? event.url : null,
      status : 'CONFIRMED',
      categories : ['portale mezzi'],
      productId : 'portalemezzi/ics'
      }*/
      const icsEvent=new ICS.VEVENT();
      const startDate=moment(event.startDate).format('YYYY-MM-DD');//.toDate();
//      const startDate=moment(event.startDate).set("h",0).toDate();
      const endDate=event.endDate?moment(event.endDate).format('YYYY-MM-DD'):null;
      icsEvent.addProp('UID');
      icsEvent.addProp('DTSTAMP', startDate, { VALUE: 'DATE-TIME' });
      icsEvent.addProp("DTSTART",startDate,{ VALUE: 'DATE-TIME' });
      if(endDate){
      icsEvent.addProp("DTEND",endDate,{ VALUE: 'DATE-TIME' });
      }
      icsEvent.addProp("SUMMARY",event.title);
      icsEvent.addProp("DESCRIPTION",event.description);
      icsEvent.addProp("CATEGORIES",["portale mezzi"]);
      icsEvent.addProp("STATUS","CONFIRMED");

      //cal.addComponent(icsEvent)
      e.push(icsEvent);
    }
    this.events = [...e];
  }

  init(params: InitIcsExporter) {
    if (params.events) {
      this.rawEvents = [];
      this.rawEvents = [...params.events];
    }
  }

  setMapFunction(map, context) {
    this.map = map;
    this.mapContext = context;
  }


  export(type: 'ics', fileName: string = 'export', events: any[] = null) {
    if (events) {
      this.parse();
    }
    if (type == 'ics') {
      const cal=new ICS.VCALENDAR();
      cal.addProp('VERSION', 2) // Number(2) is converted to '2.0'
      cal.addProp('PRODID', 'Rilancio Italia 2020');
      for(let e of this.events){
        cal.addComponent(e);
      }
      //let result = cal.toBlob()//ics.createEvents(this.events);
      var blob = cal.toBlob()//new Blob([result], { type: 'data:text/calendar;charset=utf8' });
      //window.open("data:text/calendar;charset=utf8," + escape(blob));
      saveAs(blob, fileName + '.' + type);
    } else {
      throw new Error('Tipo sbagliato') //Mi dispiace per il fra ma la tipa non ci sta
    }
  }
 }
